import { useEffect, useState } from "react";

export enum ScreenSize {
    sm,
    md,
    lg,
    "xl",
    "2xl"
};

const getScrenSize = (width: number) => {
    if (width < 640) {
        return ScreenSize.sm;
    } else if (width < 768) {
        return ScreenSize.md;
    } else if (width < 1024) {
        return ScreenSize.lg;
    } else if (width < 1280) {
        return ScreenSize.xl;
    } else {
        return ScreenSize["2xl"];
    }
};

export const useScreen = () => {
  const [width, setWidth] = useState(typeof window != 'undefined' ? window.innerWidth : 1024);

  const handleWindowSizeChange = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);

    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const screenSize = getScrenSize(width);

  return {
    width,
    screenSize
   };
};